



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { maxLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { CreateContactAttributeViewModel } from '@/messaging/models/createContactAttributeViewModel';
import Toast from '@/shared/services/toast';
import {ContactAttributeType} from '@/messaging/models/contactAttributeType';
import ReadonlyField from '@/shared/components/ReadonlyField.vue';
import Modal from '@/shared/components/Modal.vue';
import { CREATE_CONTACT_ATTRIBUTE } from '@/store/attributes/actionTypes';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';

const validName = (value: string) => value.search(/[^a-zA-Z0-9 _\-]/) === -1;

@Component({
	components: {
		ReadonlyField,
		Modal
	},
	mixins: [validationMixin],
	validations: {
		attribute: {
			name: {required, validName, maxLength: maxLength(50)},
			description: {required, maxLength: maxLength(255)}
		}
	}
})
export default class CreateAttribute extends Vue {
	@Action(CREATE_CONTACT_ATTRIBUTE) public createAttribute: (request: CreateContactAttributeViewModel) => Promise<ContactAttributeViewModel>;
	@Prop() public excludedDataTypes: ContactAttributeType[];

	public attribute: CreateContactAttributeViewModel = {
		id: '',
		name: '',
		description: '',
		type: 'text'
	};

	public dataTypeOptions = [
		{ value: ContactAttributeType.Text, display: 'Text' },
		{ value: ContactAttributeType.Number, display: 'Number' },
		{ value: ContactAttributeType.Decimal, display: 'Decimal' },
		{ value: ContactAttributeType.Date, display: 'Date' }
	];

	public updateInProgress: boolean = false;

	@Watch('attribute.name', { immediate: true })
	public onNameChange(to: string, from: string) {
		this.attribute.id = this.toCamelCase(to);
	}

	public mounted() {
		const nameInput = (this.$refs.nameInput as any);
		if (nameInput) {
			nameInput.focus();
		}

		if (this.excludedDataTypes) {
			this.dataTypeOptions = this.dataTypeOptions.filter(t => !this.excludedDataTypes.find(excluded => excluded === t.value));
		}
	}

	public closeModal() {
		this.$emit('cancel');
	}

	public isFieldNotPopulated(vuelidateObject: any, fieldName: string): boolean {
		const field = vuelidateObject[fieldName];
		return !field || (field.$invalid && !field.required && field.$dirty);
	}

	public isFieldInvalid(vuelidateObject: any, fieldName: string): boolean {
		const field = vuelidateObject[fieldName];
		return !field || (field.$invalid && field.$dirty);
	}

	public async update() {
		if (this.updateInProgress) {
			return;
		}

		this.updateInProgress = true;
		try {
			const createdAttribute = await this.createAttribute(this.attribute);
			Toast.showSuccess('Attribute successfully created');
			this.$emit('create', createdAttribute);
		} catch (err) {
			Toast.showError(err.message);
		} finally {
			this.updateInProgress = false;
		}
	}

	private toCamelCase(input: string): string {
		const words = this.toWords(input);
		let result = '';
		for (let i = 0; i < words.length; i++) {
			let word = words[i].toLowerCase();
			if (i !== 0) {
				word = word.substr(0, 1).toUpperCase() + word.substr(1);
			}

			result += word;
		}
		return result;
	}

	private toWords(input: string): RegExpMatchArray {
		if (!input) {
			return [];
		}

		const regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
		return input.match(regex) as RegExpMatchArray;
	}
}
